import { render, staticRenderFns } from "./WCounter.vue?vue&type=template&id=40b51e54&scoped=true&"
import script from "./WCounter.vue?vue&type=script&lang=js&"
export * from "./WCounter.vue?vue&type=script&lang=js&"
import style0 from "./WCounter.vue?vue&type=style&index=0&id=40b51e54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b51e54",
  null
  
)

export default component.exports